import RetoolComp from "../retool_components/retool";

export const DealCuration = () => {
  const deal_uuid = "59d23e02-72b8-11ee-bbf5-6f612b08bba1";
  return <RetoolComp component_uuid={deal_uuid} />;
};
